import api from "../api";

/* helpers */
const setParamIf = (params, key, val) => { if (val && val !== "all") params.set(key, String(val)); };
const toN = (x) => Number(String(x ?? "0").replace(",", "."));

/* Reference ro'yxatlar */
export const listWarehouses = async () => {
  const { data } = await api.get("sklad/");
  return Array.isArray(data) ? data : data?.results || [];
};
export const listPriceTypes = async () => {
  const { data } = await api.get("narx-turi/");
  return Array.isArray(data) ? data : data?.results || [];
};
export const listCategories = async () => {
  const { data } = await api.get("maxsulot-kategoriyasi/");
  return Array.isArray(data) ? data : data?.results || [];
};
export const listBrands = async () => {
  const { data } = await api.get("brend/");
  return Array.isArray(data) ? data : data?.results || [];
};

/* Maxsulotlar (filter + search) */
export const listProducts = async ({
  page, pageSize, sklad = "all", kategoriya = "all", brand = "all", search = "", ordering = "-id",
} = {}) => {
  const params = new URLSearchParams();
  if (page) params.set("page", String(page));
  if (pageSize) params.set("page_size", String(pageSize));
  if (sklad !== "all") params.set("sklad", String(sklad));
  if (kategoriya !== "all") params.set("kategoriya", String(kategoriya));
  if (brand !== "all") params.set("brand", String(brand));
  if (search?.trim()) params.set("search", search.trim());
  if (ordering) params.set("ordering", ordering);
  const { data } = await api.get(`maxsulot/?${params.toString()}`);
  const rows = Array.isArray(data) ? data : data?.results || [];
  return { rows, next: data?.next || null, previous: data?.previous || null };
};

/* Sotuvchi qidirish (ixtiyoriy) */
export const searchSellers = async ({ q = "", status, dueBefore, dueAfter } = {}) => {
  const params = new URLSearchParams();
  if (q?.trim()) params.set("search", q.trim());
  if (status) params.set("status", status);
  if (dueBefore) params.set("due_before", dueBefore);
  if (dueAfter) params.set("due_after", dueAfter);
  const { data } = await api.get(`sotuvchi/?${params.toString()}`);
  return Array.isArray(data) ? data : data?.results || [];
};

/* Ombor statistik kartalar */
export const getStockCards = async ({ sklad = "all", kategoriya = "all", brand = "all" } = {}) => {
  const params = new URLSearchParams();
  setParamIf(params, "sklad", sklad);
  setParamIf(params, "kategoriya", kategoriya);
  setParamIf(params, "brand", brand);

  // 1) Yangi endpoint
  try {
    const { data } = await api.get(`maxsulot/stats/?${params.toString()}`);
    return {
      total_qty: toN(data.total_qty),
      total_cost: toN(data.total_cost),
      total_optom: toN(data.total_optom),
      total_donaga: toN(data.total_donaga),
    };
  } catch(_) {}

  // 2) Ehtimoliy eski endpoint
  try {
    const { data } = await api.get(`stock/cards/?${params.toString()}`);
    return {
      total_qty: toN(data.total_qty),
      total_cost: toN(data.total_cost),
      total_optom: toN(data.total_optom),
      total_donaga: toN(data.total_donaga),
    };
  } catch(_) {}

  // 3) Fallback: frontda hisoblash
  const p2 = new URLSearchParams();
  setParamIf(p2, "sklad", sklad); setParamIf(p2, "kategoriya", kategoriya); setParamIf(p2, "brand", brand);
  const { data } = await api.get(`maxsulot/?${p2.toString()}`);
  const rows = Array.isArray(data) ? data : data?.results || [];

  let total_qty=0, total_cost=0, total_optom=0, total_donaga=0;
  for (const m of rows) {
    const q = Number(m?.soni || 0);
    total_qty += q;
    total_cost += q * Number(m?.tan_narxi || 0);
    const narxlar = Array.isArray(m?.narxlar) ? m.narxlar : [];
    const find = (lab) => (narxlar.find(n => String(n.sarxturi||"").toLowerCase()===lab)?.narx) ?? 0;
    total_optom  += q * Number(find("optom"));
    total_donaga += q * Number(find("donaga"));
  }
  return { total_qty, total_cost, total_optom, total_donaga };
};

/* Ombordan omborga o‘tkazish */
export const transferStock = async ({ from_sklad, to_sklad, note = "", items }) => {
  const norm3 = (x) => {
    const n = Number(String(x).replace(",", ".") || 0);
    return Number.isFinite(n) ? n.toFixed(3) : "0.000";
  };
  const payload = {
    from_sklad: Number(from_sklad),
    to_sklad: Number(to_sklad),
    note: note || "",
    items: items.map((it) => ({
      product_id: Number(it.product_id ?? it.id),
      qty: Number(it.qty),
      new_price: norm3(it.new_price),
      set_prices: it.set_prices || undefined,
    })),
  };
  const { data } = await api.post("ombor-transfer/", payload);
  return data;
};
